<template>
  <div>
    <div class="loading" v-if="fetchData">
      <load-data></load-data>
    </div>
    <b-container v-else>
      <b-row>
        <b-col md="12">
          <div class="lessonPlans">
            <h4>
              {{
                  updateLessonDetails.id == null
                    ? "Add Lesson Details"
                    : "Update Lesson Details"
              }}
            </h4>

            <br />
            <div v-if="!lessonPlanForm">
              <div class="" style="border: 2px solid #17a2b8; padding: 15px; border-radius: 5px;">
                <ul>
                  You have three options to copy course data:
                  <li>
                    Copy from University Resources <span
                      style="color: #2929aa; text-decoration: underline; cursor: pointer;"
                      @click="copy_from = 'template'; $bvModal.show('copyCoursePropertiesModel')">Click here to
                      proceed</span>
                  </li>
                  <li>Copy from previous academic year <span
                      style="color: #2929aa; text-decoration: underline; cursor: pointer;"
                      @click="copy_from = 'myinstitute'; $bvModal.show('copyCoursePropertiesModel')">Click here to
                      proceed</span>
                  </li>
                  <li>Import data using an Excel sheet <span
                      style="color: #2929aa; text-decoration: underline; cursor: pointer;"
                      @click="$emit('goto-excel');">Click here to
                      proceed</span>
                  </li>
                </ul>
                <b-modal id="copyCoursePropertiesModel" no-close-on-backdrop no-close-on-keyboard no-close-on-esc
                  hide-footer hide-header centered size="md">
                  <CopyCourseProperties :copy_from_suggestion="copy_from" :course_id="courseId"
                    @success="propertyCopyCompleted()" @cancel="$bvModal.hide('copyCoursePropertiesModel')" />
                </b-modal>
              </div>
              <div class="text-center m-2 text-primary"> OR </div>

              <p>Enter Manually <span style="color: #2929aa; text-decoration: underline; cursor: pointer;"
                  @click="openManualEntry()">Click here to
                  proceed</span></p>
            </div>

            <b-form v-if="lessonPlanForm" @submit.prevent="prepareLessonPlans()">
              <h6 class="alert alert-success text-center" v-if="lessonCreated != ''">
                {{ lessonCreated }}
              </h6>
              <div v-for="(lessonP, lessonIndex) in lessonPlans" :key="lessonIndex">
                <b-form-group class="text-right" v-if="lessonIndex != 0">
                  <span class="text-danger btn p-0 m-0" @click="removeLesson(lessonIndex)"><i
                      class="fas fa-minus-circle fa-2x"></i></span>
                </b-form-group>
                <b-form-group label="Si. No.">
                  <b-form-input placeholder="Enter Si. No." v-model="lessonP.si_no"></b-form-input>
                </b-form-group>
                <b-form-group>
                  <label class="required-label" for="">Lesson:</label>
                  <b-form-textarea placeholder="Enter Topic" rows="3" v-model="lessonP.lesson"
                    :class="{ 'is-invalid': responseErrors.lesson }"></b-form-textarea>
                  <span class="text-danger" v-if="responseErrors.lesson">{{
                      responseErrors.lesson[0]
                  }}</span>
                </b-form-group>

                <!-- <b-form-group label="Planned Date:">
                  <b-form-input v-model="lessonP.planned_dates" :class="{ 'is-invalid': responseErrors.planned_dates }" 
                  placeholder="14/02/2023,15/02/2023,..." 
                  ></b-form-input>
                  <span>Enter Date in DD/MM/YYYY format separated by comma.</span>
                  <span class="text-danger" v-if="responseErrors.planned_dates">{{ responseErrors.planned_dates[0]
                    }}</span>
                </b-form-group> -->
                <b-form-group id="input-group-1" label-for="input-1" description="">
                <b-button variant="primary" class="mb-2" size="sm" @click="addNewRow">+ Add</b-button>
             
                <table class="table table-bordered table-striped">
                  <thead class="thead-dark">
                    <tr>
                      <th>Date</th>
                      <th v-if="lessonplanheaders.planned_session">Planned Session</th>
                      <th v-if="lessonplanheaders.delivery_method">Delivery Method Plan</th>
                      <th v-if="lessonplanheaders.teaching_methodology">Teaching Methodology</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(tr, dIndex) in dateSessionDeliverymethodArray" :key="dIndex">
                      <td class="align-middle">
                        <div class="date-picker-wrapper">
                          <b-form-input
                            v-model="tr.planned_date"
                            placeholder="The date format should be dd/mm/yyyy"
                          ></b-form-input>
                        </div>
                      </td>

                      <!-- Planned Session column -->
                      <td class="align-middle" v-if="lessonplanheaders.planned_session">
                        <multiselect 
                          v-if="tr.planned_date"
                          v-model="tr.sessionIds"
                          :options="sessions"
                          :multiple="true"
                          :close-on-select="false"
                          :clear-on-select="false"
                          placeholder="Select Session's"
                          label="text"
                          track-by="value"
                          :preselect-first="false"
                          @input="updateSessionObjects(tr)"
                        ></multiselect>
                      </td>

                      <!-- Delivery Method column -->
                      <td class="align-middle" v-if="lessonplanheaders.delivery_method">
                        <span
                          v-for="(session, sIndex) in tr.sessionIds"
                          :key="sIndex"
                        >
                          {{ session.text }}<br />
                          <multiselect v-model="session.deliverymethod" :options="courseDeliveryMethods" :multiple="true"
                            :close-on-select="false" :clear-on-select="false" placeholder="Select Delivery Method Plan:"
                            :preselect-first="false" label="text" track-by="value">
                          </multiselect>

                        </span>
                      </td>

                      <!-- Teaching Methodology column (independent of Delivery Method) -->
                      <td class="align-middle" v-if="lessonplanheaders.teaching_methodology">
                        <span
                          v-for="(session, sIndex) in tr.sessionIds"
                          :key="sIndex"
                        >
                          {{ session.text }}<br />
                          <multiselect v-model="session.methedology" :options="teacherMethedologyOptions" :multiple="true"
                            :close-on-select="false" :clear-on-select="false" placeholder="Select Teaching Methodology:"
                            :preselect-first="false" label="text" track-by="value">
                          </multiselect>

                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-form-group>

                <b-form-group>
                  <label class="required-label" for="">No. of hours required:</label>
                  <b-form-input placeholder="No. of hours required"
                    :class="{ 'is-invalid': responseErrors.required_hours }" v-model="lessonP.required_hours">
                  </b-form-input>

                  <span class="text-danger" v-if="responseErrors.required_hours">{{ responseErrors.required_hours[0]
                  }}</span>
                </b-form-group>

                <b-form-group label="Select Course Outcome:">
                  <multiselect v-model="lessonP.course_outcomes" :options="courseOutcomesOptions" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" placeholder="Select CO's" label="text"
                    track-by="value" :preselect-first="false">
                  </multiselect>
                </b-form-group>
                <b-form-group label="Select Programme Outcome:" v-if="lessonplanheaders.po">
                  <multiselect v-model="lessonP.programme_outcomes" :options="programmeOutcomes" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" placeholder="Select PO's" label="text"
                    track-by="value" :preselect-first="false">
                  </multiselect>
                </b-form-group>
                <b-form-group label="Select Programme Specific Outcome:" v-if="lessonplanheaders.pso">
                  <multiselect v-model="lessonP.programme_specific_outcomes" :options="programmeSpecificOutcomes" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" placeholder="Select PSO's" label="text"
                    track-by="value" :preselect-first="false">
                  </multiselect>
                </b-form-group>
                <b-form-group label="Select Module:">
                  <b-form-select :options="courseModulesOptions" v-model="lessonP.course_module_id"></b-form-select>
                </b-form-group>

                <b-form-group label="Blooms Taxonomy Levels (Cognitive Levels):" v-if="lessonplanheaders.bloom">
                  <multiselect v-model="lessonP.cognitive_levels"
                    :options="['Remembering', 'Understanding', 'Applying', 'Analyzing', 'Evaluating', 'Creating', 'Knowledge']"
                    :multiple="true" :close-on-select="false" :clear-on-select="false"
                    placeholder="Select Cognitive levels" :preselect-first="false">
                  </multiselect>
                </b-form-group>

                <b-form-group label="Select Washington Accord Knowledge Profiles (WK):" v-if="lessonplanheaders.wk">
                  <multiselect v-model="lessonP.wks" :options="wkOptions" :multiple="true"
                    :close-on-select="false" :clear-on-select="false" placeholder="Select WK's" label="text"
                    track-by="value" :preselect-first="false">
                  </multiselect>
                </b-form-group>

                <b-form-group v-if="lessonplanheaders.sdg" label="Select Sustainable Development Goal:" label-for="input-2" description="">
                  <multiselect v-model="lessonP.sustainable_development_goal" :options="SustainableDevelopmentGoalOptions" :multiple="true"
                      :close-on-select="false" :clear-on-select="false" placeholder="Select Sustainable Development Goal:"
                      :preselect-first="false" label="text" track-by="value">
                    </multiselect>
                </b-form-group>
              </div>

              <b-form-group>
                <div class="d-flex flex-row justify-content-between">
                  <b-button variant="danger" size="md" @click="cancel()" :disabled="lessonBtn.disabled">Close</b-button>
                  <div>
                    <b-button type="submit" variant="primary" size="md" :disabled="lessonBtn.disabled">{{ lessonBtn.text
                    }}</b-button>
                  </div>
                </div>
              </b-form-group>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import CopyCourseProperties from "../CopyCourseProperties.vue"
import axios from "axios";
// import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
// import moment from "moment";
export default {
  props: ["courseId", "usergroup_id", "updateLessonDetails", "programme_config_group_id"],
  components: {
    // DatePicker, 
    CopyCourseProperties,
  },
  async created() {
    if (this.updateLessonDetails.id != null) {
      await this.loadFormOptions();
      this.lessonPlanForm = true;
      this.lessonPlans[0].si_no = this.updateLessonDetails.lesson.si_no;
      this.lessonPlans[0].lesson = this.updateLessonDetails.lesson.lesson;

      this.lessonPlans[0].required_hours = this.updateLessonDetails.lesson.required_hours;
      this.lessonPlans[0].course_id = this.updateLessonDetails.lesson.course_id;
      this.lessonPlans[0].course_module_id = this.updateLessonDetails.lesson.course_module_id;
      this.lessonPlans[0].cognitive_levels = this.updateLessonDetails.lesson.cognitive_levels;

      this.lessonPlans[0].sustainable_development_goal = this.SustainableDevelopmentGoalOptions.filter(
        option => this.updateLessonDetails.lesson.sustainable_development_goal.map(String).includes(String(option.value))
       
      );

      this.updateLessonDetails.lesson.planned_date_array.forEach((data) => {
        let sessionIds = [];
        let sessions = data.session_delivery_methods;

        let uniqueSessions = [
          ...new Map(
            sessions.map(item => [`${item.date_lessonplan_id}-${item.session_id}`, item])
          ).values()
        ];

        let deliverymethods = data.session_delivery_methods;
        if (uniqueSessions.length != 0) {
          uniqueSessions.forEach((session) => {
            sessionIds.push({
              value: session.session.id,
              text: session.session.name,
            });
          });
        } else {
          sessionIds = [];
        }
      
        let deliverymethodIds = [];
        if (deliverymethods.length != 0) {
          uniqueSessions.forEach((session,index)=>{
            deliverymethodIds = [];
            deliverymethods.forEach((deliverymethod) => {
              if(session.session_id === deliverymethod.session_id){
                deliverymethodIds.push({
                  value: deliverymethod.coursedeliverymethod ? deliverymethod.coursedeliverymethod.id : null ,
                  text: deliverymethod.coursedeliverymethod ? deliverymethod.coursedeliverymethod.name : null,
                });
                sessionIds[index].deliverymethod = deliverymethod.coursedeliverymethod ? deliverymethodIds : null;
              }
            });
          })
        } else {
          deliverymethodIds = [];
        }

        let methedologies = data.session_teacher_methedologies || [];
        let methedologyIds = [];
        if (methedologies.length != 0) {
          uniqueSessions.forEach((session, index) => {
            methedologyIds = [];
            methedologies.forEach((methedology) => {
              if (session.session_id === methedology.session_id) {
                methedologyIds.push({
                  value: methedology.teacher_methedology ? methedology.teacher_methedology.id : null,
                  text: methedology.teacher_methedology ? methedology.teacher_methedology.name : null,
                });
                sessionIds[index].methedology = methedology.teacher_methedology ? methedologyIds : null;
              }
            });
          });
        } else {
          methedologyIds = [];
        }

        this.dateSessionDeliverymethodArray.push({
          planned_date: data.planned_date,
          deliverymethodIds: deliverymethodIds,
          methedologyIds: methedologyIds,
          sessionIds: sessionIds
        });
      });

      let outcomes = this.updateLessonDetails.lesson.course_outcomes;
      if (outcomes.length != 0) {
        outcomes.forEach((outcome) => {
          this.lessonPlans[0].course_outcomes.push({
            value: outcome.id,
            text: outcome.code,
          });
        });
      } else {
        this.lessonPlans[0].course_outcomes = [];
      }
      let pOutcomes = this.updateLessonDetails.lesson.programme_outcomes;
      if (pOutcomes.length != 0) {
        pOutcomes.forEach((outcome) => {
          this.lessonPlans[0].programme_outcomes.push({
            value: outcome.id,
            text: outcome.code,
          });
        });
      } else {
        this.lessonPlans[0].programme_outcomes = [];
      }
      let psOutcomes = this.updateLessonDetails.lesson.programmespecific_outcomes;
      if (psOutcomes.length != 0) {
        psOutcomes.forEach((outcome) => {
          this.lessonPlans[0].programme_specific_outcomes.push({
            value: outcome.id,
            text: outcome.code,
          });
        });
      } else {
        this.lessonPlans[0].programme_specific_outcomes = [];
      }
      let wks = this.updateLessonDetails.lesson.wks;
      if (wks && wks.length != 0) {
        wks.forEach((wk) => {
          this.lessonPlans[0].wks.push({
            value: wk.id,
            text: wk.code,
          });
        });
      } else {
        this.lessonPlans[0].wks = [];
      }
    }
    else {
      this.addNewRow();
    }
  },

  data() {
    return {
      fetchData: false,
      lessonPlanForm: false,
      sessions : [],
      courseDeliveryMethods: [],
      dateSessionDeliverymethodArray: [],
      defaultLessonPlan: {
        planned_session: false,
        delivery_method: false,
        po: false,
        pso: false,
        wk: false,
        teaching_methodology: false,
        bloom: false,
        sdg: false,
      },
      lessonplanheaders: {},
      lessonPlans: [
        {
          si_no: "",
          lesson: "",
          required_hours: "",
          course_id: this.courseId,
          course_outcomes: [],
          programme_outcomes: [],
          programme_specific_outcomes: [],
          wks: [],
          course_module_id: null,
          cognitive_levels: [],
          sustainable_development_goal: null
        },
      ],
      lessonCreated: "",
      lessonBtn: {
        text: "Submit",
        disabled: false,
      },
      responseErrors: {},
      courseOutcomesOptions: [],
      programmeOutcomes: [],
      programmeSpecificOutcomes: [],
      wkOptions: [],
      teacherMethedologyOptions: [],
      SustainableDevelopmentGoalOptions: [
        {
          value: null,
          text: "Select Level",
          // disabled: true,
        },
        {
          value: "1",
          text: "No Poverty",
        },
        {
          value: "2",
          text: "Zero Hunger",
        },
        {
          value: "3",
          text: "Good Health and Well-being",
        },
        {
          value: "4",
          text: "Quality Education",
        },
        {
          value: "5",
          text: "Gender Equality",
        },
        {
          value: "6",
          text: "Clean Water and Sanitation",
        },
        {
          value: "7",
          text: "Affordable and Clean Energy",
        },
        {
          value: "8",
          text: "Decent Work and Economic Growth",
        },
        {
          value: "9",
          text: "Industry, Innovation, and Infrastructure",
        },
        {
          value: "10",
          text: "Reduced Inequalities",
        },
        {
          value: "11",
          text: "Sustainable Cities and Communities",
        },
        {
          value: "12",
          text: "Responsible Consumption and Production",
        },
        {
          value: "13",
          text: "Climate Action",
        },
        {
          value: "14",
          text: "Life Below Water",
        },
        {
          value: "15",
          text: "Life on Land",
        },
        {
          value: "16",
          text: "Peace, Justice, and Strong Institutions",
        },
        {
          value: "17",
          text: "Partnerships for the Goals",
        },
      ],
      courseModulesOptions: [],
      copy_from: '',
    };
  },
  methods: {
    // Dropdown data is only fetched once the form is actually shown
    async loadFormOptions() {
      this.fetchData = true;
      await this.getSessions();
      await this.getDeliverymethods();
      await this.getCourseOutcomes();
      this.getProgrammeOutcomes(),
      this.getProgrammeSpecificOutcomes(),
      this.getWks(),
      this.getTeacherMethedologies()
      await this.getCourseModules();
      await this.getCourseFileHeaderLessonPlan();
    },
    async openManualEntry() {
      await this.loadFormOptions();
      this.lessonPlanForm = true;
    },
    async getCourseFileHeaderLessonPlan() {
      const url = this.$store.getters.getAPIKey.mainAPI + `/usergroups-configuration-groups/setting/${this.programme_config_group_id}/lessonplan`;
      try {
        const response = await this.$axios.get(url);
        this.lessonplanheaders = Object.assign({}, this.defaultLessonPlan, response.data || {});
      } catch (error) {
        console.error(error);
      }
    },
    addNewRow() {
      this.dateSessionDeliverymethodArray.push({
        planned_date: "",
        deliverymethodIds : [],
        sessionIds : []
      });
    },
    updateSessionObjects(row) {
      row.sessionIds = row.sessionIds.map(session => {
        return { ...session }; // Create a new object to prevent reference issues
      });

      // Ensure the delivery method array matches the selected sessions
      row.deliverymethodIds = row.sessionIds.map(() => '');
    },
    async getSessions() {
      const url = this.$store.getters.getAPIKey.createSessions;
      await this.$axios
        .get(url)
        .then((response) => {
          let sessions = response.data;
          sessions.forEach((session) => {
            this.sessions.push({
              value: session.id,
              text: `${session.name}`
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    async getDeliverymethods() {
      this.courseDeliveryMethods = [];
      const url =
        this.$store.getters.getAPIKey.mainAPI +
        `/coursedeliverymethods`;
      await axios
        .get(url)
        .then((response) => {
          response.data.forEach(method => {
            this.courseDeliveryMethods.push({
              value: method.id, text: method.name
            });
          });
        })
        .catch((error) => {
          error;
        });
    },
    propertyCopyCompleted() {
      this.$bvModal.hide('copyCoursePropertiesModel')
      this.$emit("courseCreated", this.courseId);
      this.cancel();
    },
    addMoreLesson() {
      this.lessonPlans.push({
        si_no: "",
        lesson: "",
        required_hours: "",
        course_id: this.courseId,
        outcome: "",
        module: "",
        cognitive_levels: [],
        sustainable_development_goal: ""
      });
    },
    removeLesson(removeLesson) {
      this.lessonPlans.splice(removeLesson, 1);
    },
    async prepareLessonPlans() {
      this.lessonBtn.text = "Please wait...";
      this.lessonBtn.disabled = true;

      let clonedDateSessionDeliverymethodArray = [];
      // Deep clone the delivery data to avoid mutating reactive arrays directly
      clonedDateSessionDeliverymethodArray = this.dateSessionDeliverymethodArray.map((row) => {
        const sessionIdsOnly = [];
        const deliverymethodIdsOnly = [];
        const methedologyIdsOnly = [];

        row.sessionIds.forEach((session) => {
          sessionIdsOnly.push(session.value);
          deliverymethodIdsOnly.push(session.deliverymethod ?? null);
          methedologyIdsOnly.push(session.methedology ?? null);
        });

        return {
          planned_date: row.planned_date,
          sessionIds: sessionIdsOnly,
          deliverymethodIds: deliverymethodIdsOnly,
          methedologyIds: methedologyIdsOnly,
        };
      });
      if(this.updateLessonDetails.id == null){

        clonedDateSessionDeliverymethodArray = this.dateSessionDeliverymethodArray.map((row) => {
          let sessions = [];
          // let deliverymethodIdsOnly = [];

          row.sessionIds.forEach((session) => {
            sessions.push({
              planned_session: session.value,
              delivery_methods: session.deliverymethod,
              methedologies: session.methedology
            });
          });

          return {
            planned_date: row.planned_date,
            sessions: sessions,
            // deliverymethods: deliverymethodIdsOnly,
          };
        });
      }

      for (let i = 0; i < this.lessonPlans.length; i++) {
        const lessonP = this.lessonPlans[i];

        // Extract COs, POs, PSOs
        const co = lessonP.course_outcomes.map(outcome => outcome.value);
        const po = lessonP.programme_outcomes.map(outcome => outcome.value);
        const pso = lessonP.programme_specific_outcomes.map(outcome => outcome.value);
        const wk = lessonP.wks.map(outcome => outcome.value);

        const lessonData = {
          si_no: lessonP.si_no,
          lesson: lessonP.lesson,
          required_hours: lessonP.required_hours ?? 0,
          course_id: lessonP.course_id,
          course_outcomes: co,
          programme_outcomes: po,
          programme_specific_outcomes: pso,
          wks: wk,
          course_module_id: lessonP.course_module_id,
          cognitive_levels: lessonP.cognitive_levels,
          sustainable_development_goal: lessonP.sustainable_development_goal,
          dateSessionDeliverymethodArray: clonedDateSessionDeliverymethodArray,
        };

        let lessonPlanCreation = this.updateLessonDetails.id == null
          ? await this.createLesson(lessonData)
          : await this.updateLesson(lessonData);

        if (lessonPlanCreation) {
          if (this.updateLessonDetails.id != null) {
            this.lessonCreated = "Lesson plan updated successfully.";
            this.$emit("courseCreated", this.updateLessonDetails.lesson.course_id);
            this.clearResponse();
          } else {
            if (this.lessonPlans.length > 1) {
              this.lessonPlans.splice(i, 1);
            } else {
              this.lessonCreated = "Lesson plan created successfully.";
              this.$toast.success("Lesson Plans created successfully.", {
                position: "top",
                duration: 3000,
              });
              this.clearResponse();
              await this.$emit("courseCreated", this.courseId);
            }
          }
        } else {
          this.clearResponse();
        }
      }
    },
    async createLesson(lessonData) {
      let status = null;
      const url = this.$store.getters.getAPIKey.lessonplans;

      await this.$axios
        .post(url, lessonData)
        .then(() => {
          status = true;
          // console.log(response);
        })
        .catch((error) => {
          this.responseErrors = error.response.data.errors;
          status = false;
          // console.log(error.response);
        });
      return status;
    },
    async updateLesson(lessonData) {
      let status = null;
      const url =
        this.$store.getters.getAPIKey.lessonplans +
        `/${this.updateLessonDetails.id}`;

      await axios
        .put(url, lessonData)
        .then(() => {
          status = true;
          // console.log(response);
        })
        .catch((error) => {
          this.responseErrors = error.response.data.errors;
          status = false;

          // console.log(error.response);
        });
      return status;
    },
    getCourseOutcomes() {
      let courseOutcomeUrl = this.$store.getters.getAPIKey.getCourseOutcomes;
      const url = courseOutcomeUrl.replace("course_id", this.courseId);
      axios
        .get(url)
        .then((response) => {
          let outcomes = response.data;
          if (outcomes.length != 0) {
            outcomes.forEach((cOutcome) => {
              this.courseOutcomesOptions.push({
                value: cOutcome.id,
                text: cOutcome.code,
              });
            });
          }
          // console.log(response);
        })
        .catch(() => {
          // console.log(error.response);
        });
    },
    async getProgrammeOutcomes() {
      let url = this.$store.getters.getAPIKey.programOutcome + `?course=${this.courseId}`;
      await this.$axios.get(url).then((response) => {
        let outcomes = response.data;
          if (outcomes.length != 0) {
            outcomes.forEach((pOutcome) => {
              this.programmeOutcomes.push({
                value: pOutcome.id,
                text: pOutcome.code,
              });
            });
          }
      });
    },
    async getProgrammeSpecificOutcomes() {
      let url = this.$store.getters.getAPIKey.programSpecificOutcome + `?course=${this.courseId}`;
      await this.$axios.get(url).then((response) => {
        let outcomes = response.data;
          if (outcomes.length != 0) {
            outcomes.forEach((poOutcome) => {
              this.programmeSpecificOutcomes.push({
                value: poOutcome.id,
                text: poOutcome.code,
              });
            });
          }
      });
    },
    async getWks() {
      let url = this.$store.getters.getAPIKey.wk + `?course=${this.courseId}`;
      await this.$axios.get(url).then((response) => {
        let wks = response.data;
          if (wks.length != 0) {
            wks.forEach((wk) => {
              this.wkOptions.push({
                value: wk.id,
                text: wk.code,
              });
            });
          }
      });
    },
    async getTeacherMethedologies() {
      let url = this.$store.getters.getAPIKey.teacherMethedology;
      await this.$axios.get(url).then((response) => {
        let methedologies = response.data;
          if (methedologies.length != 0) {
            methedologies.forEach((methedology) => {
              this.teacherMethedologyOptions.push({
                value: methedology.id,
                text: methedology.name,
              });
            });
          }
      });
    },
    getCourseModules() {
      let courseModuleUrl = this.$store.getters.getAPIKey.getCourseModules;
      const url = courseModuleUrl.replace("course_id", this.courseId);
      axios
        .get(url)
        .then((response) => {
          this.courseModulesOptions = [
            { value: null, text: "Select Module", disabled: true },
          ];
          let modules = response.data;
          if (modules.length != 0) {
            modules.forEach((cModule) => {
              this.courseModulesOptions.push({
                value: cModule.id,
                text: cModule.module,
              });
            });
          }
          this.fetchData = false;
          // console.log(response);
        })
        .catch(() => {
          // console.log(error.response);
        });
    },
    clearResponse() {
      this.lessonBtn.text = "Submit";
      this.lessonBtn.disabled = false;
      setTimeout(() => {
        if (this.lessonCreated != "") {
          this.lessonCreated = "";
          this.cancel();
        }
        this.responseErrors = {};
      }, 3000);
    },
    cancel() {
      if (this.updateLessonDetails.id != null) {
        this.$emit("cancelUpdate");
      }
      this.lessonPlans = [
        {
          si_no: "",
          lesson: "",
          required_hours: "",
          course_id: [],
          course_outcomes: null,
          programme_outcomes: null,
          programme_specific_outcomes: null,
          course_module_id: null,
          cognitive_levels: [],
          sustainable_development_goal: null
        },
      ];
      this.$emit("cancel");
    },
  },
  watch: {
    courseId: {
      deep: true,
      handler: function () {
        if (this.courseId != null) {
          for (let i = 0; i < this.lessonPlans.length; i++) {
            this.lessonPlans[i].course_id = this.courseId;
          }
        }
      },
    },
  },
};
</script>

<style >
.lessonPlans form label {
  font-size: 18px;
  font-weight: bold;
}
</style>
